export const BUSINESS_DEMO_SUCCESS_PASSWORD_MANAGEMENT_INTRO = {
  "en": "Dashlane Password Management makes it easy to:",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Dashlane Password Management makes it easy to:",
  "it": "Dashlane Password Management makes it easy to:",
  "ja": "Dashlane Password Management makes it easy to:",
  "ko": "Dashlane Password Management makes it easy to:",
  "nl": "Dashlane Password Management makes it easy to:",
  "pt-pt": "Dashlane Password Management makes it easy to:",
  "sv": "Dashlane Password Management makes it easy to:",
  "zh": "Dashlane Password Management makes it easy to:"
}